var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCommercial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 0.666748H28.7812L34.875 10.0417H1.125L7.21875 0.666748Z",
    stroke: "#3C3C3C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 17.5417V29.6667C6.75 30.219 7.19772 30.6667 7.75 30.6667H28.25C28.8023 30.6667 29.25 30.219 29.25 29.6667V17.5417",
    stroke: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.0417V13.7917C3 15.8628 4.67893 17.5417 6.75 17.5417V17.5417C8.82107 17.5417 10.5 15.8628 10.5 13.7917V10.0417L12.375 0.666748",
    stroke: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.0417V13.7917C10.5 15.8628 12.1789 17.5417 14.25 17.5417V17.5417C16.3211 17.5417 18 15.8628 18 13.7917V10.0417V0.666748",
    stroke: "#3C3C3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 10.0417V13.7917C33 15.8628 31.3211 17.5417 29.25 17.5417V17.5417C27.1789 17.5417 25.5 15.8628 25.5 13.7917V10.0417L23.625 0.666748",
    stroke: "#3C3C3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 10.0417V13.7917C25.5 15.8628 23.8211 17.5417 21.75 17.5417V17.5417C19.6789 17.5417 18 15.8628 18 13.7917V10.0417V0.666748",
    stroke: "#3C3C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.2917H25.5",
    stroke: "#3C3C3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 21.2917V30.6667M23.625 21.2917V30.6667M18 21.2917V30.6667",
    stroke: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommercial);
export default __webpack_public_path__ + "static/media/icon-commercial.ce70ecb48e393eec280c43d6fdcb6162.svg";
export { ForwardRef as ReactComponent };